import GooglePay from 'features/moveMoney/screens/GooglePay/GooglePay';
import React from 'react';

export default function Page() {
  return <GooglePay />;
}
